import * as React from 'react';
import { translation } from 'easit--localization';
import { ProgressStateModel } from 'eTip--common';
import ContentLoader from "react-content-loader";
import { observer } from 'mobx-react';

export interface IContentLoaderProps {
    color: string;
    flashColor: string;
}

export interface IContentLoaderWidthProps extends IContentLoaderProps {
    width: number;
}

export interface ICarouselLoaderProps extends IContentLoaderWidthProps {
    height: number;
}

const MobileLiveOneEventInListLoaderMts = (props: IContentLoaderProps) => (
    <ContentLoader
        height={112}
        speed={3}
        primaryColor={props.color}
        secondaryColor={props.flashColor}
        style={{ width: '100%', height: 112 }}
        ariaLabel=""
    >
        <rect x="7" y="8" rx="4" ry="4" width="291" height="24" />
        <rect x="7" y="38" rx="3" ry="3" width="264" height="12" />
        <rect x="368" y="8" rx="0" ry="0" width="25" height="25" />
        <rect x="7" y="55" rx="0" ry="0" width="124" height="48" />
        <rect x="140" y="55" rx="0" ry="0" width="124" height="48" />
        <rect x="273" y="55" rx="0" ry="0" width="124" height="48" />
    </ContentLoader>
)

const MobileLiveEventsLoaderWithCategory = (props: IContentLoaderWidthProps) => (
    <>
        <ContentLoader
            height={24}
            speed={3}
            primaryColor={props.color}
            secondaryColor={props.flashColor}
            style={{ width: '100%', height: 24 }}
            ariaLabel=""
        >
            <rect x="0" y="1" rx="0" ry="0" width={props.width} height="23" />
        </ContentLoader>
        <MobileLiveOneEventInListLoaderMts {...props} />
        <MobileLiveOneEventInListLoaderMts {...props} />
        <MobileLiveOneEventInListLoaderMts {...props} />
    </>
)

const MobileStandardEventsLoader = (props: IContentLoaderProps) => (
    <ContentLoader
        height={125}
        speed={3}
        primaryColor={props.color}
        secondaryColor={props.flashColor}
        style={{ width: '100%', height: 125 }}
        ariaLabel=""
    >
        <rect x="7" y="15" rx="4" ry="4" width="291" height="24" />
        <rect x="7" y="45" rx="3" ry="3" width="264" height="12" />
        <rect x="368" y="15" rx="0" ry="0" width="25" height="25" />
        <rect x="7" y="63" rx="0" ry="0" width="127" height="48" />
        <rect x="137" y="63" rx="0" ry="0" width="127" height="48" />
        <rect x="267" y="63" rx="0" ry="0" width="127" height="48" />
    </ContentLoader>
)

const CarouselLoader = (props: ICarouselLoaderProps) => {
    // 2.33 is widht/height ratio of banner images
    //same in bannerContainer and progressContentComponent
    const width = props.width;
    const height = props.height;
    const rectTop = 0;
    const rectHeight = height;
    return <ContentLoader
        width={width}
        height={height}
        speed={3}
        primaryColor={props.color}
        secondaryColor={props.flashColor}
        ariaLabel=""
    >
        <rect x="0" y={rectTop} width={width} height={rectHeight} />
    </ContentLoader>
}

const MobileStandardCategoriesLoader = (props: IContentLoaderWidthProps) => {
    const width = props.width;
    const boxHeight = 60;
    return <ContentLoader
        width={width}
        speed={3}
        height={boxHeight * 4 + 8}
        primaryColor={props.color}
        secondaryColor={props.flashColor}
        ariaLabel=""
    >
        <rect x="0" y="0" width={width} height={boxHeight} />
        <rect x="0" y={boxHeight + 2} width={width} height={boxHeight} />
        <rect x="0" y={(boxHeight + 2) * 2} width={width} height={boxHeight} />
        <rect x="0" y={(boxHeight + 2) * 3} width={width} height={boxHeight} />
    </ContentLoader>
}

const MobileLivePageLoaderMts = (props: IContentLoaderWidthProps) => {
    const width = props.width;

    return <>
        <ContentLoader
            width={width}
            speed={3}
            height={59}
            primaryColor={props.color}
            secondaryColor={props.flashColor}
            ariaLabel=""
        >
            <rect x="0" y="0" width={width} height={59} />
        </ContentLoader>

        <MobileLiveEventsLoaderWithCategory {...props} width={width} />
        <MobileLiveEventsLoaderWithCategory {...props} width={width} />
    </>
}

const MobileEventDetailLoader = (props: IContentLoaderWidthProps) => {
    const width = props.width;

    return <>
        <ContentLoader
            width={width}
            speed={3}
            height={500}
            primaryColor={props.color}
            secondaryColor={props.flashColor}
            ariaLabel=""
        >
            <rect x="10" y="10" width={30} height={30} />
            <rect x="50" y="10" width={200} height={20} />
            <rect x="50" y="35" width={150} height={15} />
            <rect x="50" y="55" width={100} height={15} />
            <rect x="0" y="80" width={(width / 3) - 2} height={40} />
            <rect x={(width / 3)} y="80" width={(width / 3) - 2} height={40} />
            <rect x={(width / 3) * 2} y="80" width={(width / 3) - 2} height={40} />
            <rect x="10" y="130" width={200} height={20} />
            <rect x="10" y="160" width={(width / 2) - 2} height={50} />
            <rect x={(width / 2) + 11} y="160" width={(width / 2) - 22} height={50} />
            <rect x="10" y="220" width={200} height={20} />
            <rect x="10" y="250" width={(width / 2) - 2} height={50} />
            <rect x={(width / 2) + 11} y="250" width={(width / 2) - 22} height={50} />
            <rect x="10" y="250" width={(width / 2) - 2} height={50} />
            <rect x={(width / 2) + 11} y="250" width={(width / 2) - 22} height={50} />
            <rect x="10" y="310" width={200} height={20} />
            <rect x="10" y="340" width={(width / 2) - 2} height={50} />
            <rect x={(width / 2) + 11} y="340" width={(width / 2) - 22} height={50} />
            <rect x="10" y="400" width={(width / 2) - 2} height={50} />
            <rect x={(width / 2) + 11} y="400" width={(width / 2) - 22} height={50} />
        </ContentLoader>
    </>
}

const MobileCashOutListLoader = (props: IContentLoaderWidthProps) => {
    const width = props.width

    return <>
        <ContentLoader
            width={width}
            speed={3}
            height={51}
            primaryColor={props.color}
            secondaryColor={props.flashColor}
            ariaLabel=""
        >
            <rect x="10" y="1" width={width - 20} height={50} />

        </ContentLoader>
    </>
}

const MobileSearchLoader = (props: IContentLoaderWidthProps) => {
    const width = props.width;

    let topRowHeight = 26;
    let rowHeight = 61;

    return <>
        <ContentLoader
            width={width}
            speed={3}
            height={topRowHeight + 3 * rowHeight + 3}
            primaryColor={props.color}
            secondaryColor={props.flashColor}
            ariaLabel=""
        >
            <rect x="3" y="0" width={width - 6} height={topRowHeight} />
            <rect x="3" y={topRowHeight + 1} width={width - 6} height={rowHeight} />
            <rect x="3" y={topRowHeight + 2 + rowHeight} width={width - 6} height={rowHeight} />
            <rect x="3" y={topRowHeight + 3 + 2 * rowHeight} width={width - 6} height={rowHeight} />
        </ContentLoader>
    </>
}

export interface IProgressContentCommon {
    state: ProgressStateModel;
    children?: React.ReactNode;
    errorMessage?: string;
}

export interface IProgressContent extends IProgressContentCommon {
    placeholderHeight?: string;
    inline?: boolean;
    loadingText?: string;
    className?: string;
}

export interface IProgressContentAdvanced extends IProgressContentCommon {
    loaderType: 'mobile-live-events' | 'mobile-standard-events' | 'carousel' | 'mobile-standard-categories' |
    'mobile-live-page' | 'mobile-event-detail' | 'mobile-top-bets' | 'mobile-cashout-list' | 'mobile-search';
    repeatCount?: number;
    color: string;
    flashColor: string;
    width: number; // expected screenInfo.bodyWidth (not screenWidth)
}

export interface IProgressContentAdvancedWithHeight extends IProgressContentAdvanced {
    height: number;
}

const repeater = (cnt: number, loader: React.ReactNode) => {
    let ret = [];
    if (cnt) {
        for (let i = 0; i < cnt; i++) {
            ret.push(loader);
        }
    }
    else {
        ret.push(loader);
    }
    return ret.map((item, idx) => <React.Fragment key={idx}>{item}</React.Fragment>);
}

export const ProgressContent = observer((props: IProgressContent) => {
    return props.state === ProgressStateModel.Loading
        ? <div key={'progress'} className={`${!props.inline ? 'progress-loader-wrapper p-2' : ''} ${props.className}`}
            style={{ height: props.placeholderHeight }}
        >
            <div className={`${!props.inline ? 'progress-loader-content' : ''}`}><span className="fas fa-spinner fa-spin"></span> {props.loadingText == null ? translation().general_Loading : props.loadingText} </div>
        </div>
        : props.state === ProgressStateModel.Failed
            ? (
                <div key={'failed'} className="p-2">{props.errorMessage ? props.errorMessage : translation().general_ProgressContentError}</div>
            ) : (
                <React.Fragment key={'content'}>{props.children}</React.Fragment>
            );
});

const getAdvancedLoader = (props: IProgressContentAdvanced) => {
    // it does not work with observer!
    switch (props.loaderType) {
        case 'mobile-live-events': return <> {repeater(Math.ceil(props.repeatCount / 2 /* 2 events per category, see also liveEventsContainer.tsx! */), <MobileLiveEventsLoaderWithCategory {...props} />)} </>;
        case 'mobile-standard-events': return <> {repeater(props.repeatCount, <MobileStandardEventsLoader {...props} />)} </>;
        case 'mobile-standard-categories': return <>{repeater(Math.ceil(props.repeatCount / 4), <MobileStandardCategoriesLoader {...props} />)}</>;
        case 'mobile-live-page': return <>{MobileLivePageLoaderMts(props)}</>;
        case 'mobile-event-detail': return <MobileEventDetailLoader {...props} />;
        case 'mobile-top-bets': return <> {repeater(props.repeatCount, <MobileStandardEventsLoader {...props} />)}</>
        case 'mobile-cashout-list': return <>{repeater(5, <MobileCashOutListLoader  {...props} />)}</>
        case 'mobile-search': return <>{<MobileSearchLoader  {...props} />}</>
    }
    throw new Error("Unexpected advanced loader");
};


export const ProgressContentAdvanced = observer((props: IProgressContentAdvanced) => {
    //IProgressContentAdvanced is too general, cannot have specific props for each loader. As soon to release, skipping it. Probably also add observer.

    // similar copy ProgressContentAdvanced and ProgressContentCarusel

    return props.state === ProgressStateModel.Loading
        ? getAdvancedLoader(props)
        : props.state === ProgressStateModel.Failed
            ? (
                <div key={'failed'} className="p-2">{props.errorMessage ? props.errorMessage : translation().general_ProgressContentError}</div>
            ) : (
                <React.Fragment key={'content'}>{props.children}</React.Fragment>
            );
});

export const ProgressContentCarusel = observer((props: IProgressContentAdvancedWithHeight) => {
    return props.state === ProgressStateModel.Loading
        ? CarouselLoader(props)
        : props.state === ProgressStateModel.Failed
            ? (
                <div key={'failed'} className="p-2">{props.errorMessage ? props.errorMessage : translation().general_ProgressContentError}</div>
            ) : (
                <React.Fragment key={'content'}>{props.children}</React.Fragment>
            );
});
